<div class="flex justify-content-start" [ngClass]="{'flex-column': fullWidth}">
  <div appFileDrop class="drop-zone" [ngClass]="{'w-full p-2': fullWidth}"
    (filesDropped)="onFilesDropped($event)" (click)="fileInput.click()" >
    <div class="upload-area">
      <i class="pi pi-upload text-2xl"></i>
      <p class="mt-2">Haz clic o arrastra los archivos que deseas cargar.</p>
    </div>
    <input
      type="file"
      #fileInput
      accept=".pdf, .xlsx, .xls, .png, .jpeg, jpg,
          application/pdf,
          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
          application/vnd.ms-excel"
      (change)="onFileSelected($event)"
      fileLimit="5"
      maxFileSize="5000000"
      multiple
      hidden
    />
  </div>
  <div>
    <ul>
      <li *ngFor="let file of selectedFiles; let i = index">
          {{ file.name }}
          <span (click)="removeFile(i)" class="pi pi-times click-icon" style="color: red;"></span>
      </li>
    </ul>
  </div>
</div>

